import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {deleteMyAd} from 'services/myAd/delete';
interface IUseDeleteAdProps {
  isNavigate?: boolean;
  refetch?: () => void;
  action?: () => void;
}
const useDeleteAd = ({isNavigate, refetch, action}: IUseDeleteAdProps) => {
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: ({guid, delete_reason, type}: deleteMyAdProps) => {
      return deleteMyAd({guid, delete_reason, type});
    },
    onSuccess: () => {
      isNavigate && navigate(-1);
      refetch && refetch();
      action && action();
    },
    onError: () => {
      toast.error('مشکلی در حذف چت پیش آمده');
    },
  });
  return {isLoading, mutate};
};

export default useDeleteAd;
